import { render, staticRenderFns } from "./ComparePage.vue?vue&type=template&id=2542e1ca&"
import script from "./ComparePage.vue?vue&type=script&lang=js&"
export * from "./ComparePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports